<template>
  <div class="d-flex flex-wrap">
    <div class="col-12 col-lg-4 d-flex flex-wrap">
      <OrdersMapSummary :data="summary" :ordersQuantity="ordersQuantity" />
    </div>

    <div id="geocoding-map" class="col-12 col-lg-8 map relative">
      <gmap-map :center="geoloc" :zoom="6" style="width: 100%; height: 100vh">
        <gmap-marker
          v-for="(c, index) in clients"
          :key="index"
          :position="c.position"
          :clickable="true"
          @click="changeIndex(index)"
        >
          <gmap-info-window v-if="showByIndex === index">
            <a
              :href="`#/clients/${c.id}`"
              target="_blank"
              class="text-decoration-none"
            >
              <h6>
                {{ c.company ? c.company : c.name }}
              </h6>
            </a>

            <p>CA : {{ parseFloat(c.totalTurnover, 10) / 100 }} €</p>
            <p>
              Total : {{ c.ordersQuantity }} commande{{
                c.ordersQuantity > 1 ? "s" : ""
              }}
            </p>

            <p v-if="c.merchantCompany">{{ c.merchantCompany }}</p>
            <p v-if="c.merchantCorporate">{{ c.merchantCorporate }}</p>

            <p>Concepts :</p>

            <ul>
              <li v-for="concept in c.concepts" :key="concept">
                {{ concept }}
              </li>
            </ul>
          </gmap-info-window>
        </gmap-marker>
      </gmap-map>
    </div>
  </div>
</template>

<script>
import OrdersMapSummary from "@/components/order/OrdersMapSummary.vue";

export default {
  components: {
    OrdersMapSummary,
  },

  props: {
    clients: { type: Array, required: true },
    summary: { type: Object, required: true },
    ordersQuantity: { type: Number, required: true },
  },

  data() {
    return {
      geoloc: {
        lat: 46.3969,
        lng: 2.6879,
      },
      gmapIsLoaded: false,
      showByIndex: null,
    };
  },

  async mounted() {
    try {
      const google = await this.$gmapApiPromiseLazy();

      this.gmapIsLoaded =
        google?.maps && Object.keys(google.maps).includes("places");
    } catch (e) {
      this.gmapIsLoaded = false;
    }
  },

  methods: {
    changeIndex(index) {
      if (this.showByIndex && this.showByIndex !== index) {
        return (this.showByIndex = index);
      }

      return (this.showByIndex = this.showByIndex ? null : index);
    },
  },
};
</script>
